module.exports = __webpack_public_path__ + "img/booking_com_logo.5e0bfb65.png";